// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rR_WaSxfe8EwLhsHwTfL {
  position: relative;
}

.GXTApl2irmTwWXWLRG6g {
  padding-bottom: 63px;
}

.g7M4Ke4SfVreMLSjxk19 {
  height: 95%;
  overflow: hidden;
  background: rgb(var(--primary-bg));
  z-index: 301;
  overflow-x: hidden;
}

  
  .H5m2qDopjEuGF2S1g1L_ {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
    justify-items: start;
    gap: 5px;
    margin-bottom: 20px;
  }
  
  .sd312zxPM7rto000F3h8 {
    display: flex;
    flex-direction: row;
    justify-content: end;
    align-items: center;
    gap: 5px;
    margin-bottom: 20px;
  }
  
  
  .ZMmOrnWwdqwdilvV6rDp {
    color: #1c77ff;
    font-size: 16.5px;
    font-weight: 540;
    letter-spacing: 0.43px;
    padding: 0;
    background: transparent;
    cursor: pointer;
    border: none;
    transition: color 0.3s ease 0s;
  }
  
  .ZMmOrnWwdqwdilvV6rDp:hover {
    color: #055ada;
    background: transparent;
  }
  
  .YqKJGe9afMK3_A825EF7 {
    font-size: 17px;
    font-weight: 760;
    letter-spacing: 0.43px;
    line-height: 129.41%;
    margin: 0 auto;
  }
  
  .lkvO_ZhZctokKxCGDyIH {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  .vX7kytDKauoq0TaMo0yb {
    position: absolute;
    right: 50%;
    top: 50%;
    z-index: 50;
    transform: translate(50%, -50%);
    padding: 0;
    background: transparent;
  }
  
  .baTVQE6vJEx2TLdn8iek {
    padding: 14px 21px;
    font-style: 17px;
    font-weight: 540;
    line-height: 129%;
    border-radius: 30px;
    background: #007AFF;
    letter-spacing: 0.63px;
    width: 100%;
    height: auto;
    margin-top: 20px;
  }
  
  .baTVQE6vJEx2TLdn8iek:hover {
    background: #007AFF;
  }
  
  .Ep660o9zB6Mg2gJg6obN {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 20px);
    padding-top: 20px;
  }
  
  .zcvhnBqQw8iLla_TweLQ {
    font-weight: 540;
  }
  
  .etoXDrQzmER37Gt9OaZh {
    margin: 20px 0;
  }
  .VOB2VL1LxX6JlTYiAYbA {
    margin-bottom: 15px;
    font-size: 20px;
    font-weight: 760;
    line-height: 120%;
  }
  .zq5niOga95QLYZPLy5Qo {
    padding: 13px;
    font-size: 17px;
    width: 100%;
    border-radius: 10px;
    background: rgba(118, 118, 128, 0.12);
    border: none;
    color: rgba(60, 60, 67, 0.6);
    margin-bottom: 20px;
  }
  
  
  /* check position */
  
  .wKouv1T37gDYyotiiTEA {
    background: radial-gradient(53.5% 50% at 50% 50%, rgba(0, 234, 23, 0.50) 0%, rgba(255, 255, 255, 0.00) 100%), transparent;
  }
  
  .R8pFJ6PH659CmG5ZQBGx {
    background: radial-gradient(53.5% 50% at 50% 50%, rgba(234, 42, 0, 0.50) 0%, rgba(255, 255, 255, 0.00) 100%), transparent;
  }
  
  .xF0EhQC90qBXaiiDUys6 {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 20px;
  }
  
  .xF0EhQC90qBXaiiDUys6 img {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 170px;
    height: 170px;
    margin: 0 auto 8px auto;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/swap/swap.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;AACpB;;;EAGE;IACE,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,oBAAoB;IACpB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;EACrB;;;EAGA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,+BAA+B;IAC/B,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,qCAAqC;IACrC,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;EACrB;;;EAGA,mBAAmB;;EAEnB;IACE,yHAAyH;EAC3H;;EAEA;IACE,yHAAyH;EAC3H;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,uBAAuB;EACzB","sourcesContent":[".wrapper {\n  position: relative;\n}\n\n.wrapperPadding {\n  padding-bottom: 63px;\n}\n\n.modal {\n  height: 95%;\n  overflow: hidden;\n  background: rgb(var(--primary-bg));\n  z-index: 301;\n  overflow-x: hidden;\n}\n\n  \n  .modalTop {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    align-items: center;\n    justify-items: start;\n    gap: 5px;\n    margin-bottom: 20px;\n  }\n  \n  .modalTopRight {\n    display: flex;\n    flex-direction: row;\n    justify-content: end;\n    align-items: center;\n    gap: 5px;\n    margin-bottom: 20px;\n  }\n  \n  \n  .modalTopButton {\n    color: #1c77ff;\n    font-size: 16.5px;\n    font-weight: 540;\n    letter-spacing: 0.43px;\n    padding: 0;\n    background: transparent;\n    cursor: pointer;\n    border: none;\n    transition: color 0.3s ease 0s;\n  }\n  \n  .modalTopButton:hover {\n    color: #055ada;\n    background: transparent;\n  }\n  \n  .modalTitle {\n    font-size: 17px;\n    font-weight: 760;\n    letter-spacing: 0.43px;\n    line-height: 129.41%;\n    margin: 0 auto;\n  }\n  \n  .modalContent {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  .modalContentSwap {\n    position: absolute;\n    right: 50%;\n    top: 50%;\n    z-index: 50;\n    transform: translate(50%, -50%);\n    padding: 0;\n    background: transparent;\n  }\n  \n  .button {\n    padding: 14px 21px;\n    font-style: 17px;\n    font-weight: 540;\n    line-height: 129%;\n    border-radius: 30px;\n    background: #007AFF;\n    letter-spacing: 0.63px;\n    width: 100%;\n    height: auto;\n    margin-top: 20px;\n  }\n  \n  .button:hover {\n    background: #007AFF;\n  }\n  \n  .container {\n    display: flex;\n    flex-direction: column;\n    height: calc(100vh - 20px);\n    padding-top: 20px;\n  }\n  \n  .modalContentMain {\n    font-weight: 540;\n  }\n  \n  .passwordBlock {\n    margin: 20px 0;\n  }\n  .passwordLabel {\n    margin-bottom: 15px;\n    font-size: 20px;\n    font-weight: 760;\n    line-height: 120%;\n  }\n  .passwordInput {\n    padding: 13px;\n    font-size: 17px;\n    width: 100%;\n    border-radius: 10px;\n    background: rgba(118, 118, 128, 0.12);\n    border: none;\n    color: rgba(60, 60, 67, 0.6);\n    margin-bottom: 20px;\n  }\n  \n  \n  /* check position */\n  \n  .success {\n    background: radial-gradient(53.5% 50% at 50% 50%, rgba(0, 234, 23, 0.50) 0%, rgba(255, 255, 255, 0.00) 100%), transparent;\n  }\n  \n  .error {\n    background: radial-gradient(53.5% 50% at 50% 50%, rgba(234, 42, 0, 0.50) 0%, rgba(255, 255, 255, 0.00) 100%), transparent;\n  }\n  \n  .checkContent {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  .checkContent img {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 170px;\n    height: 170px;\n    margin: 0 auto 8px auto;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `rR_WaSxfe8EwLhsHwTfL`,
	"wrapperPadding": `GXTApl2irmTwWXWLRG6g`,
	"modal": `g7M4Ke4SfVreMLSjxk19`,
	"modalTop": `H5m2qDopjEuGF2S1g1L_`,
	"modalTopRight": `sd312zxPM7rto000F3h8`,
	"modalTopButton": `ZMmOrnWwdqwdilvV6rDp`,
	"modalTitle": `YqKJGe9afMK3_A825EF7`,
	"modalContent": `lkvO_ZhZctokKxCGDyIH`,
	"modalContentSwap": `vX7kytDKauoq0TaMo0yb`,
	"button": `baTVQE6vJEx2TLdn8iek`,
	"container": `Ep660o9zB6Mg2gJg6obN`,
	"modalContentMain": `zcvhnBqQw8iLla_TweLQ`,
	"passwordBlock": `etoXDrQzmER37Gt9OaZh`,
	"passwordLabel": `VOB2VL1LxX6JlTYiAYbA`,
	"passwordInput": `zq5niOga95QLYZPLy5Qo`,
	"success": `wKouv1T37gDYyotiiTEA`,
	"error": `R8pFJ6PH659CmG5ZQBGx`,
	"checkContent": `xF0EhQC90qBXaiiDUys6`
};
export default ___CSS_LOADER_EXPORT___;
